import React, { useState, useMemo } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./FlightCalendar.css";

const FlightCalendar = ({ data, onSelectFlight }) => {
  const [selectedDate, setSelectedDate] = useState(null);

  const formatDate = (date) => date.toISOString().split("T")[0];

  const flightsForDate = (date) => {
    if (!date) return [];
    const dateStr = formatDate(date);
    return data.filter((flight) => flight.dates === dateStr);
  };

  // Grupuj loty według dat dla lepszej wydajności
  const flightsByDate = useMemo(() => {
    const grouped = {};
    data.forEach(flight => {
      if (flight.dates) {
        if (!grouped[flight.dates]) {
          grouped[flight.dates] = [];
        }
        grouped[flight.dates].push(flight);
      }
    });
    return grouped;
  }, [data]);

  const tileContent = ({ date, view }) => {
    if (view !== "month") return null;

    const dateStr = formatDate(date);
    const flights = flightsByDate[dateStr];

    if (!flights || flights.length === 0) return null;

    // Znajdź najniższą cenę dla tego dnia
    const minPrice = Math.min(...flights.map(f => f.price));
    const flightCount = flights.length;

    return (
      <div className="tile-content">
        <div className="flight-count-badge">{flightCount}</div>
        <div className="price-badge">{minPrice} zł</div>
      </div>
    );
  };

  const tileClassName = ({ date, view }) => {
    if (view !== "month") return null;

    const dateStr = formatDate(date);
    const flights = flightsByDate[dateStr];

    if (!flights || flights.length === 0) return null;

    return 'has-flights';
  };

  const selectedFlights = selectedDate ? flightsForDate(selectedDate) : [];
  const sortedSelectedFlights = [...selectedFlights].sort((a, b) => a.price - b.price);

  return (
    <div className="flight-calendar-container">
      <div className="calendar-header">
        <h2 className="calendar-title">Kalendarz Lotów</h2>
        <p className="calendar-subtitle">Wybierz datę, aby zobaczyć dostępne loty</p>
      </div>

      <div className="calendar-wrapper">
        <Calendar
          onClickDay={setSelectedDate}
          tileContent={tileContent}
          tileClassName={tileClassName}
          value={selectedDate}
          locale="pl-PL"
          minDate={new Date()}
        />
      </div>

      {selectedDate && (
        <div className="selected-date-section">
          <div className="selected-date-header">
            <h3 className="selected-date-title">
              {selectedDate.toLocaleDateString("pl-PL", {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </h3>
            <span className="flights-count-badge">
              {sortedSelectedFlights.length} {sortedSelectedFlights.length === 1 ? 'lot' : 'lotów'}
            </span>
          </div>

          {sortedSelectedFlights.length > 0 ? (
            <div className="flights-list">
              {sortedSelectedFlights.map((flight) => (
                <div key={flight.id} className="flight-item" onClick={() => onSelectFlight && onSelectFlight(flight)}>
                  <div className="flight-item-header">
                    <div className="flight-destination-info">
                      <h4 className="flight-country">{flight.name}</h4>
                      <p className="flight-airports">{flight.country} • {flight.airports}</p>
                    </div>
                    <div className="flight-price-tag">
                      <span className="price-amount">{flight.price}</span>
                      <span className="price-currency">zł</span>
                    </div>
                  </div>

                  <div className="flight-item-footer">
                    <div className="flight-meta">
                      <span className="meta-badge provider">{flight.provider}</span>
                      {flight.brand && flight.brand !== "TUI" && (
                        <span className="meta-badge brand">{flight.brand}</span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-flights-message">
              <div className="no-flights-icon">✈️</div>
              <p>Brak lotów w tym dniu</p>
            </div>
          )}
        </div>
      )}

      {!selectedDate && (
        <div className="calendar-info">
          <p className="info-text">
            💡 Kliknij na datę z zaznaczonymi lotami, aby zobaczyć szczegóły
          </p>
        </div>
      )}
    </div>
  );
};

export default FlightCalendar;
